var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.625 20.6056V18.7309H2.88469V9.40375C2.88469 7.72271 3.40354 6.23635 4.44125 4.94469C5.47875 3.65302 6.81083 2.82687 8.4375 2.46625V1.6875C8.4375 1.25354 8.58927 0.884584 8.89281 0.580626C9.19635 0.276876 9.5649 0.125 9.99844 0.125C10.4322 0.125 10.8013 0.276876 11.1056 0.580626C11.4102 0.884584 11.5625 1.25354 11.5625 1.6875V2.46625C13.1892 2.82687 14.5213 3.65302 15.5588 4.94469C16.5965 6.23635 17.1153 7.72271 17.1153 9.40375V18.7309H19.375V20.6056H0.625ZM9.99781 24.1153C9.37594 24.1153 8.84427 23.8941 8.40281 23.4516C7.96115 23.0091 7.74031 22.4771 7.74031 21.8556H12.2597C12.2597 22.4792 12.0382 23.0117 11.5953 23.4531C11.1524 23.8946 10.6199 24.1153 9.99781 24.1153ZM4.75969 18.7309H15.2403V9.40375C15.2403 7.95667 14.7288 6.72156 13.7056 5.69844C12.6823 4.6751 11.4471 4.16344 10 4.16344C8.55292 4.16344 7.31771 4.6751 6.29438 5.69844C5.27125 6.72156 4.75969 7.95667 4.75969 9.40375V18.7309Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.af4f2da774736ac056cc57c389b761cb.svg";
export { ForwardRef as ReactComponent };